import React ,{ useState, useEffect , useMemo  }from 'react';
import axios from 'axios';
import '../css/app-admin.scss';
// action="https://id.jobadder.com/connect/authorize" method="GET"
/* 
  */
const FormIntegrationComponent = ({data}) => {
	// console.log(data , "datadata");

    const [accessToken, setAccessToken] = useState("");
    const [clientID, setClientID] = useState("");
    const [secretID, setSecretID] = useState("");
    const [scope, setScope] = useState("");
    const [redirectURL, setRedirectURL] = useState("");
    const [jobadderAPIURL, setJobadderAPIURL] = useState("");

    const [isConnectedSuccess, setIsConnectedSuccess] = useState(false);

    const [isConnectedTextDisplay, setIsConnectedTextDisplay] = useState("Connecting to app...");
  
    const [displayBUtton, setDisplayBUtton] = useState(false);
    
    const AuthCodeRedirect = () =>{

        console.log("redirect");
        const url_auth = "https://id.jobadder.com/connect/authorize";
        var parameter_query = "?response_type=code";
        parameter_query += "&client_id="+clientID;
        parameter_query += "&scope="+scope;
        parameter_query += "&redirect_uri="+redirectURL;
        // console.log(url_auth+parameter_query);
        window.location.assign(url_auth+parameter_query);
    }

    useEffect(() => {
        setAccessToken(data['access_token']??"");
        setClientID(data['client_id']??"");
        setScope(data['scope']??"");
        setSecretID(data['secret_id']??"");
        setRedirectURL(data['redirect_uri']??"");
        setJobadderAPIURL(data['jobadder_api_url']??"");
        // console.log(data['jobadder_api_url'] , "jobadder_api_url");
    } , data );


    // Function to fetch jobs from the JobAdder API
    const fetchJobs = async () => {
        try {
            const token = accessToken; // Replace with your actual access token
            const apiUrl = jobadderAPIURL;
        
            const params = {
                limit: 10,
                sortBy: 'lastModified',
                sortOrder: 'desc',
                action: 'get_jobadder',
                nonce: react_ajax_object.ajax_react_nonce,
                offset: 0,
                endPoint : "jobs"
            };

          


            try {
                const response = await axios.get(react_ajax_object.ajax_react, { params: params });
            
        
               if(response.data?.totalCount){setIsConnectedSuccess(true);}
               else{setIsConnectedTextDisplay("Can't Connect to app");}

               setDisplayBUtton(true);
              } catch (error) {
                console.error('Error fetching data:', error);
                // setError(error.message || 'An error occurred.'); // Display a user-friendly error message
              }




        } catch (error) {
             console.error('Error fetching jobs:', error);
       
        } 
    };

    // Use useEffect to fetch jobs when the component mounts
    useEffect(() => {
        fetchJobs();
    }, [setJobadderAPIURL]);

    return (
        <div>
         
           <div className='boxform'>
                <p >To connect your application with JobAdder, you'll need to add the following code to your configuration file (usually wp-config.php):</p>
              
                <code style={{  display:"block",    background: "#a0a0a0" ,    padding: "12px",    color: "#f7f7f7" }}>
                    /* JOBADDER INTEGRATION - CLIENT CREDENTIALS */ <br/>
                    define('JOBADDER_CLIENT_ID', {"'{client_id}'"}); <br/>
                    define('JOBADDER_CLIENT_SECRET',  {"'{secret_id}'"});
                </code>
                <p>Replace the placeholders ({"{client_id}"}, {"{secret_id}"}) with the actual values you can find in your JobAdder developer account.</p>
            {/*   <input type="hidden" name="client_id" id="client_id" value="" required readOnly/>

                <input type="hidden" name="response_type" id="response_type" value="" required/>
                <input type="hidden" name="scope" id="scope" value="read write offline_access" required/>
                <input type="hidden" name="redirect_uri" id="redirect_uri" value="" required/> */}
             

            
                {!isConnectedSuccess && <span style={{
                    textAlign: "center",
                    display: "block",
                    marginTop: "27px",
                    fontSize: "14px"
                }}
                > {isConnectedTextDisplay} </span>} 


                {((accessToken === "" || !isConnectedSuccess  ) && displayBUtton) &&  
                <button type="submit" 
               disabled={clientID !== "" || 
               secretID !== "" || 
               scope !== "" ? false  : true }
               
               onClick={
                   clientID !== "" || 
                   secretID !== "" || 
                   scope !== ""
                   ? AuthCodeRedirect : ""} 
               >
                Integrate Now</button>} 


                {(accessToken !== "" && isConnectedSuccess  && displayBUtton)   &&  
                <button className='connected'>Connected</button>} 


              
            
             



                </div>
        </div>
    )
}


export default FormIntegrationComponent;
